import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SettingsView from '../views/SettingsView.vue'
import AcademicYear from "../views/AcademicYear.vue"
import AcademicResults from '@/views/AcademicResults.vue'
import ResultView from '@/views/ResultView.vue'
import TeachersList from '@/views/TeachersList.vue'
import TeachersSubject from '@/views/TeachersSubject.vue'
import SubjectList from '@/views/SubjectList.vue'
import SubjectGrade from '@/views/SubjectGrade.vue'
import AssignmentView from '@/views/AssignmentView.vue'
import AssignmentQestions from '@/views/AssignmentQestions.vue'
import StudentsView from '@/views/StudentsView.vue'
import QuizList from '@/views/QuizList.vue'
import QuizGroup from '@/views/QuizGroup.vue'
import QuizParicipants from '@/views/QuizParicipants.vue'
import TestManager from '@/views/TestManager.vue'
import TeachersStudents from '@/views/TeachersStudent.vue'
import StudentTeachers from '@/views/StudentTeachers.vue'
import TestSubjects from '@/views/TestSubjects.vue'
import TestGrade from '@/views/TestGrade.vue'
import TestQuestions from '@/views/TestQuestions.vue'
import SubjectGroups from '@/views/SubjectGroups.vue'
import AssignmentList from '@/views/AssignmentList.vue'
import WriteAssignment from '@/views/WriteAssignment.vue'
import AssignmentSubmission from "@/views/AssignmentSubmission"
import AssignmentMarking from "@/views/AssignmentMarking"
import StudentsBirthday from "@/views/StudentsBirthday"
import WriteTest from "@/views/WriteTest"
import TestGroupStudents from "@/views/TestGroupStudents"
import TestMarking from "@/views/TestMarking"


const routes = [
  {
    path: '',
    name: 'home',
    component: HomeView,
    meta: { title: 'Dashboard | GTA Admin' }
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: 'Dashboard | GTA Admin' }
  },
  {
    path: '/academicyear',
    name: 'academicYear',
    component: AcademicYear
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView
  },
  {
    path: '/academicresult/:id',
    name: 'academicresult',
    component: AcademicResults
  },
  {
    path: '/resultsview',
    name: 'resultsview',
    component: ResultView
  },
  {
    path: '/teacherslist',
    name: 'teacherslist',
    component: TeachersList
  },
  {
    path: '/teachersubjects/:id',
    name: 'teachersubjects',
    component: TeachersSubject
  },
  {
    path: '/subjectlist',
    name: 'subjectlist',
    component: SubjectList
  },
  {
    path: '/subjectgrade/:subject',
    name: 'subjectgrade',
    component: SubjectGrade
  },
  {
    path: '/assignment/:sub/:group',
    name: 'assignment',
    component: AssignmentView
  },
  {
    path: '/assignmentquestions/:id',
    name: 'assignmentquestions',
    component: AssignmentQestions
  },
  {
    path: '/students',
    name: 'students',
    component: StudentsView
  },
  {
    path: '/quizmanager',
    name: 'quizmanager',
    component: QuizList
  },
  {
    path: '/quizmanager/groups/:id',
    name: 'quizgroup',
    component: QuizGroup
  },
  {
    path: '/quizmanager/participants/:id',
    name: 'quizparticipants',
    component: QuizParicipants
  },
  {
    path: '/testmanager',
    name: 'testmanager',
    component: TestManager
  },
  {
    path: '/teacherstudents/:id',
    name: 'teacherstudents',
    component: TeachersStudents
  },
  {
    path: '/studentteachers/:id',
    name: 'studentteachers',
    component: StudentTeachers
  },
  {
    path: '/testsubjects/:id',
    name: 'testsubjects',
    component: TestSubjects
  },
  {
    path: '/testmanager/choosegrade/:id/:sub',
    name: 'testgrade',
    component: TestGrade
  },
  {
    path: '/testmanager/questions/:id/:sub/:group',
    name: 'testquestions',
    component: TestQuestions
  },
  {
    path: '/subjectlist/:sub',
    name: 'subjectgroups',
    component: SubjectGroups
  },
  {
    path: '/assignmentlist',
    name: 'assignmentlist',
    component: AssignmentList
  },
  {
    path: '/writeassignment/:id',
    name: 'writeassignment',
    component: WriteAssignment
  },
  {
    path: '/submissionlist/:id',
    name: 'submissionlist',
    component: AssignmentSubmission
  },
  {
    path: '/markassignment/:id/:stu',
    name: 'markassignment',
    component: AssignmentMarking
  },
  {
    path: '/birthdays/:type',
    name: 'birthdays',
    component: StudentsBirthday
  },
  {
    path: '/writetest/:id/:group',
    name: 'writetest',
    component: WriteTest
  },
  {
    path: '/testmanager/mark/studentlist/:group/:id',
    name: 'markstudentlist',
    component: TestGroupStudents
  },
  {
    path: '/testmanager/mark/:group/:id/:stu',
    name: 'marktest',
    component: TestMarking
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})
router.afterEach((to) => {
  document.title = to.meta.title || 'GTA Admin'
})

export default router
